import { useState } from "react";
import Button from "../../../utils/components/Button";
const ButtonLayout = ({ items, checkedItem, onChecked, disabled }) => {
  const [checked, setChecked] = useState(checkedItem);

  const handleChange = (item) => {
    if (disabled) return;
    setChecked(item);
    onChecked(item);
  };

  return (
    <div className="d-flex w-100 justify-content-center">
      {items.map((item, index) => (
        <Button
          type="button"
          className={`btn border rounded shadow-sm fw-bold px-4 ${
            checked === item ? "btn-orange text-white" : "btn-secondary"
          }`}
          onClick={() => handleChange(item)}
          key={index}
        >
          {item}
        </Button>
      ))}
    </div>
  );
};
export default ButtonLayout;
